export const downloadFile = async (url: string, suggestedName?: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = suggestedName || '';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(objectUrl);
  } catch {
    const anchor = document.createElement('a');
    anchor.href = url;
    if (suggestedName) anchor.setAttribute('download', suggestedName);
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  }
};
